import React, { useContext, useState } from "react";
import GridItemText from "./GridItemText";
import { Button, FormControl, FormControlLabel, FormLabel, Grid, MenuItem, Radio, RadioGroup, Select } from "@mui/material";
import module from "./AddressInputs.module.css";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";
import { fetchPostCode } from "../../../util/postCode";
import SelectInputWay from "./SelectInputWay";

const AddressInputs = ({ getCustomAttribute }) => {
  const [isAddressLoading, setIsAddressLoading] = useState(false);
  const [addressError, setAddressError] = useState(null);
  const [isMultipleAddress, setIsMultipleAddress] = useState(false);
  const [multipleAddress, setMultipleAddress] = useState([]);
  const [inputWithAddress, setInputWithAddress] = useState(false);

  const { settingParam, clearAddress, setAddress, changePostCode, pageStatus, inputtedAddress, handleInputtedAddress, basicInfo, setBasicInfo } =
    useContext(RewardSettingContext);
  const { address } = settingParam;
  const { isManualInputAddress } = pageStatus;

  const initialProcess = () => {
    setIsAddressLoading(false);
    setAddressError(null);
    setIsMultipleAddress(false);
    setMultipleAddress([]);
    // clearAddress();
  };

  const validation = (value) => {
    if (value.includes("-")) {
      setAddressError("郵便番号はハイフンなしで入力してください。");
      return false;
    }
    if (value.length === 0) {
      return "";
    }
    if (!value.match(/^[0-9]+$/)) {
      setAddressError("半角数値のみで入力してください。");
      return false;
    }
    if (value.length > 7) {
      setAddressError("郵便番号は7桁で入力してください。");
      return false;
    }

    return true;
  };

  const finishProcess = (data, value) => {
    handleInputtedAddress(value)
    if (data.length === 0) {
      setAddressError("郵便番号が見つかりませんでした。");
      return null;
    } else if (data.length > 1) {
      const multiAddress = data.map((d) => d.allAddress);
      setMultipleAddress(multiAddress);
      setIsMultipleAddress(true);
      return null;
    } else if (data.length === 1) {
      setAddress(data[0].allAddress);
    }
  };

  const handlePostCode = async (e) => {
    try {
      initialProcess();
      setInputWithAddress(false);
      const { value } = e.target;
      if (!validation(value)) return null;
      document.getElementById("post_code").value = value;
      setIsAddressLoading(false);
      if (value.length === 7) {
        const data = await fetchPostCode(value);
        finishProcess(data, value);
      }
      setIsAddressLoading(false);
    } catch (e) {
      console.log(e);
      setIsAddressLoading(false);
    }
  };

  const handleAddressSelect = (e) => {
    try {
      const { value } = e.target;
      setAddress(multipleAddress[value]);
      setIsMultipleAddress(false);
      setMultipleAddress([]);
    } catch (e) {
      console.log(e);
    }
  };


  const judgeIsAvailableSelectOcrAddress = () => {
    const ocrAddress = getCustomAttribute("ocr_address");
    if (!ocrAddress) return false;
    return true;
  }
  const isAvailableSelectOcrAddress = judgeIsAvailableSelectOcrAddress();

  const isDisplayManualInputAddress = () => {
    if (!getCustomAttribute("ocr_address")) return true;
    if (isManualInputAddress) return true;
    return false;
  }

  return (
    <>
      <SelectInputWay
        getCustomAttribute={getCustomAttribute}
        isAvailableSelectOcrAddress={isAvailableSelectOcrAddress}
      />
      {isDisplayManualInputAddress() && (
        <>
          <GridItemText
            label="郵便番号"
            placeholder={"例：5300000"}
            type={"post_code"}
            name={"post_code"}
            defaultValue={inputtedAddress || getCustomAttribute("post_code")}
            onChange={handlePostCode}
            error={addressError}
          />
          {isMultipleAddress && (
            <Grid item xs={12} sx={{ textAlign: "left", marginBottom: "24px" }}>
              <label className={module.label}>{"住所を選択してください"}</label>
              <span>*</span>
              <Select
                id="address-select"
                name="address-select"
                defaultValue={""}
                fullWidth
                onChange={handleAddressSelect}
              >
                <MenuItem value={""}>
                  <em>{"選択してください"}</em>
                </MenuItem>
                {multipleAddress.map((addressData, i) => (
                  <MenuItem key={`address_${i}`} value={i}>
                    {addressData}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}
          <GridItemText
            label="都道府県・市区町村(自動入力)"
            disabled
            placeholder={"例：大阪府大阪市北区中之島"}
            type={"address"}
            name={"address"}
            value={address}
          />
          <GridItemText
            label="住所1"
            placeholder={"例：番地など"}
            type={"address_first"}
            name={"address_first"}
            defaultValue={basicInfo.addressFirst !== "" ? basicInfo.addressFirst : getCustomAttribute("address_first")}
            onBlur={(e) => setBasicInfo({ ...basicInfo, addressFirst: e.target.value })}
          />
          <GridItemText
            label="住所2"
            placeholder={"例：建物名・号室など"}
            type={"address_second"}
            name={"address_second"}
            defaultValue={basicInfo.addressSecond !== "" ? basicInfo.addressSecond : getCustomAttribute("address_second")}
            onBlur={(e) => setBasicInfo({ ...basicInfo, addressSecond: e.target.value })}
            notRequired
          />
        </>
      )}
    </>
  );
};

export default AddressInputs;
